// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  paymentsButtonDetails: Object,
};

const DeleteSelectedPaymentLink = (props: Props) => {
  const {
    visible,
    close,
    submit,
    paymentsButtonDetails,
  } = props;

  const deleteSelectedPaymentLink = () => {
    submit(paymentsButtonDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedPaymentLink} type="danger">Deactivate</SpButton>,
      ]}
      title="Deactivate Payment Button"
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to deactivate this Payment Button?</h6>
        <SpH5 className="pb-3">
          <div>{paymentsButtonDetails.description ? paymentsButtonDetails.description : <>&#8211;</>}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteSelectedPaymentLink;
